import React, { createContext, useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { fetchTokensForRef, fetchTokensForGuid, login } from "./authentication";
import useSessionStorage from "./Hooks";
import Unauthorized from './Unauthorized';
import { validateAuthConfig } from './validateAuthConfig';
export var AuthContext = createContext({ accessToken: '', priceToken: '', logOut: function () { return null; }, error: null });
export var AuthProvider = function (_a) {
    var authConfig = _a.authConfig, children = _a.children;
    var _b = useSessionStorage('ng_ts_auth_token', null), accessToken = _b[0], setAccessToken = _b[1];
    var _c = useSessionStorage('ng_ts_price_token', null), priceToken = _c[0], setPriceToken = _c[1];
    var _d = useState(), tokenData = _d[0], setTokenData = _d[1];
    var _e = useState(null), error = _e[0], setError = _e[1];
    validateAuthConfig(authConfig);
    function logOut() {
        setAccessToken(null);
        setPriceToken(null);
        setTokenData(undefined);
    }
    function handleTokenResponseForRef(access_token, response) {
        if (response.active.toString() === "true") {
            response.client_id = authConfig.clientId;
            setAccessToken(access_token);
            setPriceToken(response.price_token);
            setTokenData(response);
        }
        else
            logOut();
    }
    function handleTokenResponseForGuid(response) {
        if (response) {
            var decodedJwtToken = jwtDecode(response.jwtToken);
            setAccessToken(response.jwtToken);
            setPriceToken(response.priceToken);
            setTokenData(decodedJwtToken);
        }
        else
            logOut();
    }
    // Runs once on page load
    useEffect(function () {
        if (!accessToken) {
            var urlParams_1 = new URLSearchParams(window.location.search);
            if (!urlParams_1.get('token') && !urlParams_1.get('guid_token')) {
                // This should not happen. There should be a 'code' parameter in the url by now..."
                login(authConfig);
                var error_description = urlParams_1.get('error_description') || 'query does not have token parameter!';
                setError(error_description);
                logOut();
            }
            else { // Request token from auth server with the auth code
                if (urlParams_1.get('guid_token') && urlParams_1.get('guid_token') != "") {
                    fetchTokensForGuid(authConfig)
                        .then(function (tokens) {
                        handleTokenResponseForGuid(tokens);
                    })
                        .catch(function (error) {
                        setError(error);
                    });
                }
                else {
                    fetchTokensForRef(authConfig)
                        .then(function (tokens) {
                        handleTokenResponseForRef(urlParams_1.get('token') || "", tokens);
                    })
                        .catch(function (error) {
                        setError(error);
                    });
                }
            }
        }
        else {
            var decodedJwtToken = jwtDecode(accessToken);
            setTokenData(decodedJwtToken);
        }
    }, []);
    return (React.createElement(AuthContext.Provider, { value: { accessToken: accessToken, priceToken: priceToken, logOut: logOut, tokenData: tokenData, error: error } }, accessToken ? children : React.createElement(Unauthorized, null)));
};
